
import { Icon, Modal, Button, Tab, Tabs } from '@descomplica/vue-components';
import Vue from 'vue';
import Summary from '@/components/modals/showcase/microcertificate/pages/Summary.vue';
import { Route } from 'vue-router';
import Curriculum from '@/components/modals/showcase/microcertificate/pages/Curriculum.vue';

interface Data {
  isActive: Boolean;
  currentTab: string;
  courseSlug: string;
}

export default Vue.extend({
  components: {
    Curriculum,
    Summary,
    Icon,
    Modal,
    Button,
    Tab,
    Tabs,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    currentCourseSlug: {
      type: String,
      default: '',
    },
  },
  data(): Data {
    return {
      isActive: this.active,
      courseSlug: this.currentCourseSlug,
      currentTab: 'microcertificate-summary',
    };
  },
  watch: {
    $route(to): void {
      this.showCaseOpenMicrocertificateModal(to);
    },
  },
  methods: {
    onCloseClick() {
      this.$data.isActive = false;
    },
    showCaseOpenMicrocertificateModal(to: Route): void {
      if (to?.query?.openMicrocertificate === 'open') {
        this.$data.isActive = true;
        this.$data.courseSlug = to.query.courseSlug;
        const query = { ...this.$route.query };
        delete query.openMicrocertificate;
        delete query.courseSlug;
        this.$router.replace({ query });
      }
    },
    isSelected(tabName: string): boolean {
      return this.currentTab === tabName;
    },
    selectTab(tab: string): void {
      this.currentTab = tab;
    },
  },
});
